export default {
  notifications: state => state.notifications,
  notificationsPagination: state => state.notificationsPagination,
  unreadNotifications: state => state.unreadNotifications,
};
